import { ContractFunnelDto, FeesDto } from "api/pricing";

/**
 * Keeps the value each tunnel fee had when it was first received (initial load, before any
 * broker change). A fee id belongs to one tunnel, so the first value seen stays the reference.
 */
export const recordTunnelFeeValues = (tunnelFeeValues: Record<string, number>, funnels: ContractFunnelDto[]) => {
  funnels.forEach((funnel) => {
    funnel.fees?.forEach((fee) => {
      if (tunnelFeeValues[fee.id] === undefined) {
        tunnelFeeValues[fee.id] = fee.value;
      }
    });
  });
};

/**
 * Custom fees sent back to the server: only the fees whose value differs from the tunnel value.
 * The server rewrites every custom fee as a fixed amount excluding tax, so an untouched fee must
 * not be sent or the quote would not be priced like the contractualisation.
 */
export const mapModifiedFees = (fees: FeesDto[] | undefined, tunnelFeeValues: Record<string, number>) =>
  (fees ?? [])
    .filter((fee) => tunnelFeeValues[fee.id] === undefined || fee.value !== tunnelFeeValues[fee.id])
    .map((fee) => ({ id: fee.id, value: fee.value }));
